import { render, staticRenderFns } from "./Noor.vue?vue&type=template&id=43c10efe"
import script from "./Noor.vue?vue&type=script&lang=js"
export * from "./Noor.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports